import {filterStore} from "../../filterStore";

export default {
	data: () =>
	{
		return {
			loading: 0,
			loadedFirstTime: false,
			lastReload: null
		};
	},

	async mounted()
	{
		// Init the reloadTimer
		this.initReloadTimer();

		// Load data for the first time
		await this.updateComponent(true);


	},

	methods: {
		incrementLoading()
		{
			return ++this.loading;
		},

		decrementLoading()
		{
			--this.loading;

			if (this.loading === 0)
				this.loadedFirstTime = true;

			return this.loading;
		},

		initReloadTimer()
		{
			this.lastReload = Date.now();

			// Every 10 seconds, check if we need to reload
			setInterval(this.updateComponent, 2 * 60 * 1000);
		},

		async updateComponent(force = false)
		{
			let secondsSinceLastSync = Math.floor(Date.now() - this.lastReload) / 1000;
			// console.log('Seconds since last sync: ', secondsSinceLastSync);

			if (force || secondsSinceLastSync >= 15) {
				this.lastReload = Date.now();
				await this.updateHandler();
			}
		},

		piechartHasData(chartData)
		{
			if (!chartData)
				return false;

			let data = chartData['datasets'];

			if (!data)
				return false;

			return data[0]['data'].some(count => count > 0);
		},

		linechartHasData(chartData)
		{
			if (!chartData)
				return false;

			let datasets = chartData['datasets'];

			if (!datasets)
				return false;

			return datasets.some(dataset => dataset['data'].length > 0);
		}

	},

	computed: {
		filterStore: () => filterStore,

		hasData()
		{
			throw 'hasData is not implemented in the component';
		}
	},

	watch: {
		filterStore: {
			deep: true,
			handler(newVal)
			{
				this.updateComponent(true);
			}
		}
	}
};